import * as jsforce from 'jsforce'
import type { SyncSettingWrapper, SyncToggleResponse, SyncNowResponse } from '../../types/salesforce'

/**
 * 現在のユーザーのGoogle Calendar同期設定を取得
 * （存在しない場合は自動的に作成される）
 */
export async function getCurrentUserSyncSetting(conn: jsforce.Connection): Promise<SyncSettingWrapper> {
  try {
    // @RestResource @HttpGet のメソッドを呼び出し
    const result = await conn.request<SyncSettingWrapper>({
      method: 'GET',
      url: `${conn.instanceUrl}/services/apexrest/GoogleCalendarSyncController`,
      headers: {
        Authorization: `Bearer ${conn.accessToken}`,
        'Content-Type': 'application/json',
      },
    })
    return result
  } catch (error) {
    // エラーをそのままスロー（呼び出し側でハンドリング）
    throw new Error(`同期設定の取得に失敗しました: ${error}`)
  }
}

/**
 * Google認証URLを取得
 */
export async function getAuthenticationUrl(conn: jsforce.Connection): Promise<string> {
  try {
    const response = await conn.requestPost('/services/apexrest/GoogleCalendarSyncController/getAuthenticationUrl', {})
    const result = typeof response === 'string' ? JSON.parse(response) : response
    return result.url
  } catch (error) {
    console.error('Get authentication URL error:', error)
    throw new Error(`認証URLの取得に失敗しました: ${error}`)
  }
}

/**
 * Google認証をテスト
 */
export async function testAuthentication(conn: jsforce.Connection): Promise<SyncToggleResponse> {
  try {
    const response = await conn.requestPost('/services/apexrest/GoogleCalendarSyncController/testAuthentication', {})
    const result = typeof response === 'string' ? JSON.parse(response) : response
    return result
  } catch (error) {
    console.error('Test authentication error:', error)
    throw new Error(`認証テストに失敗しました: ${error}`)
  }
}

/**
 * Google Calendar同期のON/OFFを切り替え
 * @param enabled true=ON, false=OFF
 */
export async function toggleSync(conn: jsforce.Connection, enabled: boolean): Promise<SyncToggleResponse> {
  try {
    const response = await conn.requestPost<string>('/services/apexrest/GoogleCalendarSyncController/toggleSync', {
      enabled,
    })
    const result = typeof response === 'string' ? JSON.parse(response) : response
    return result
  } catch (error) {
    console.error('Toggle sync error:', error)
    throw new Error(`同期設定の変更に失敗しました: ${error}`)
  }
}

/**
 * Google Calendar同期を今すぐ実行
 */
export async function syncNow(conn: jsforce.Connection): Promise<SyncNowResponse> {
  try {
    const response = await conn.requestPost<string>('/services/apexrest/GoogleCalendarSyncController/syncNow', {})
    const result = typeof response === 'string' ? JSON.parse(response) : response
    return result
  } catch (error) {
    console.error('Sync now error:', error)
    throw new Error(`同期の実行に失敗しました: ${error}`)
  }
}
